import coreStore from './core-store'
import Axios from 'axios'

const remoteResource = 'cashflow/api/v1/cash-effects';

const store = coreStore.queryStore(coreStore.createCoreStore('cashEffect', remoteResource));

export default store;